import styles from './SponsoredBadge.module.scss';

export function SponsoredBadge({ link }: { link: string }) {
  return (
    <div className={styles.container}>
      <a className={styles.content} href={link} target="_blank" rel="noreferrer">
        реклама • adengi.ru
      </a>
    </div>
  );
}
